const NotificationService = "/notifications";
const NotificationController = `${NotificationService}/notifications`;

export const NotificationManagementService  = {
  Notifications : NotificationController,
  Users: `${NotificationController}/users`,
  Seen:(notificationId: number) => `${NotificationController}/${notificationId}`
};
